// src/data/mock.data.about.ts
import { cockpitGet, COCKPIT_URL } from '../config/cockpit';

import type { CollaboratorData } from './../models/Collaborator';
import type { NavigationLink } from './../models/Header';
import type { TeamData } from './../models/Team';

export const aboutLinks: NavigationLink[] = [
  { id: 0, title: 'about', linkTo: '/about' },
  { id: 1, title: 'expertise', linkTo: '/#expertise' },
  { id: 2, title: 'projects', linkTo: '/projects' },
  { id: 3, title: 'contact', linkTo: '/#contact' },
];

type CockpitAsset = {
  path?: string;
};

type CockpitCollabItem = {
  name: string;
  role?: string;
  about?: string;
  link?: string;
  image?: CockpitAsset;
  order?: number;
};

type CockpitTeamItem = {
  name: string;
  role?: string;
  about?: string;
  biography?: string;
  education?: string;
  image?: CockpitAsset;
  order?: number;
};

function imageUrl(asset?: CockpitAsset): string | undefined {
  if (!asset?.path) return undefined;

  return `${COCKPIT_URL}/storage/uploads${asset.path}`;
}

export async function getTeamData(): Promise<TeamData[]> {
  const items: CockpitTeamItem[] = await cockpitGet<CockpitTeamItem[]>(
    '/api/content/items/Team'
  );

  items.sort(
    (a: CockpitTeamItem, b: CockpitTeamItem) =>
      (a.order ?? 0) - (b.order ?? 0)
  );

  return items.map((item: CockpitTeamItem) => ({
    name: item.name,
    role: item.role,
    about: item.about,
    biography: item.biography,
    education: item.education,
    image: imageUrl(item.image),
  }));
}

export async function getCollabData(): Promise<CollaboratorData[]> {
  const items: CockpitCollabItem[] = await cockpitGet<CockpitCollabItem[]>(
    '/api/content/items/Collab'
  );

  items.sort(
    (a: CockpitCollabItem, b: CockpitCollabItem) =>
      (a.order ?? 0) - (b.order ?? 0)
  );

  return items.map((item: CockpitCollabItem) => ({
    name: item.name,
    role: item.role,
    about: item.about,
    link: item.link,
    image: imageUrl(item.image),
  }));
}